import React from 'react';
import {view} from '@sail/ui';

export function SalesChatResponse({children}: {children: React.ReactNode}) {
  return <view.div css={{marginRight: 'xxlarge'}}>{children}</view.div>;
}
